<template>
  <div class="comment-background-view">
    <el-row>
      <el-col :span="12">
        <div class="comment-title">备注</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <p class="item-comment">{{comment}}</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    comment: String
  }
};
</script>

<style>
.comment-title {
    font-family: PingFangSC-Medium;
  font-size: 13px;
  color: #53c384;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 16px;
  margin-left: 16px;
}
.comment-background-view {
  height: auto;
  background: #ffffff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  width: 359px;
  margin-left: 8px;
}
.item-comment {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  width: 333px;
  height: auto;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-line;
  /* letter-spacing: 0;
  text-align: left;
  line-height: 18px; */
  margin-left: 16px;
}
</style>